"use strict";var e=require("react"),u=0;exports.useUniqueId=function(n){return e.useMemo((function(){return"".concat(null!=n?n+"-":"","unique-id-").concat(u++)}),[n])};
//# sourceMappingURL=useUniqueId-129c23df.js.map
